import { createSelector } from 'reselect';

import * as constants from '../helpers/constants/dataTypeConstants';

import {
  getGridPriceData,
  getSelectedInboundDate,
  getSelectedOutboundDate,
} from '.';

import type { State } from './types';

const getSelectedDaysPrice = createSelector(
  (state: State) => state,
  getSelectedOutboundDate,
  getSelectedInboundDate,
  (state, outboundDate, inboundDate) => {
    let totalPrice = null;

    const outboundPrice = getGridPriceData(
      state,
      outboundDate,
      constants.OUTBOUND_DIRECTION,
    ).price;

    if (outboundPrice) {
      totalPrice = outboundPrice;
      if (inboundDate) {
        const inboundPrice = getGridPriceData(
          state,
          inboundDate,
          constants.INBOUND_DIRECTION,
        ).price;

        if (inboundPrice) {
          totalPrice += inboundPrice;
        } else {
          totalPrice = null;
        }
      }
    }
    return totalPrice;
  },
);

export default getSelectedDaysPrice;
